(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-nlv2-videos]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const section = rail.closest('.nlv2-reels');
      const videos = [...rail.querySelectorAll('video')];
      rail.querySelectorAll('.nlv2-reelcard__frame').forEach(frame => {
        const video = frame.querySelector('video');
        const button = frame.querySelector('[data-nlv2-play]');
        button.addEventListener('click', () => {
          videos.forEach(other => { if (other !== video) other.pause(); });
          video.controls = true;
          video.play().catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => {
          videos.forEach(other => { if (other !== video) other.pause(); });
          button.hidden = true;
        });
        video.addEventListener('pause', () => { button.hidden = false; });
        video.addEventListener('ended', () => { button.hidden = false; video.controls = false; });
      });
      const move = direction => {
        const card = rail.querySelector('.nlv2-reelcard');
        const gap = parseFloat(getComputedStyle(rail).gap) || 0;
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      section.querySelector('[data-nlv2-prev]').addEventListener('click', () => move(-1));
      section.querySelector('[data-nlv2-next]').addEventListener('click', () => move(1));
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
      }, { threshold: 0.15 });
      videos.forEach(video => observer.observe(video));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
